import { Clock3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { minutesToTime } from '@/lib/publishQueues/calendarSelection';
import { ScheduleSelect } from './ScheduleSelect';

const TIMES = Array.from({ length: 288 }, (_, index) => {
  const time = minutesToTime(index * 5);
  return { value: time, label: time };
});

export function QueueTimeSelect({ id, value, onChange }: { id: string; value: string; onChange: (value: string) => void }) {
  const { t } = useTranslation();
  const options = TIMES.some((time) => time.value === value) ? TIMES : [...TIMES, { value, label: value }]
    .sort((a, b) => a.value.localeCompare(b.value));
  return <ScheduleSelect id={id} value={value} options={options} onChange={onChange}
    searchLabel={t('publishQueues.form.searchTime')}
    icon={<Clock3 className="hidden h-4 w-4 shrink-0 text-muted-foreground sm:block" aria-hidden="true" />}
    customOption={(search) => {
      const match = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(search.trim());
      if (!match) return undefined;
      const time = `${match[1].padStart(2, '0')}:${match[2]}`;
      return { value: time, label: time, keywords: [search.trim()] };
    }} />;
}
